import * as ReactDOM from "react-dom/client";

import "./styles/global.css";
import App from "./App";
import { Provider } from 'react-redux'; // Redux Provider ekleyin
import store from './redux/store'; // Redux mağazasını içe aktarın

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>

);